import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app.module';

// Note(Moris): polyfill Intl per Safari 8 e 9 (utilizzato dalle Pipe per la formattazione delle date e valute)
// ToDo: includere il polyfill solo quando necessario
import 'intl';
import 'intl/locale-data/jsonp/it.js';

platformBrowserDynamic().bootstrapModule(AppModule);



// WEBPACK FOOTER //
// ./src/app/main.ts